import { format } from 'date-fns'
import { IData } from './request/response'

const buildUrl = (
  calendarId: number,
  pageSize: number,
  page: number,
  startDate?: Date,
  finishDate?: Date,
): string => {
  return `/api/v2/reservation/list/id_calendar/${calendarId}/page_size/${pageSize}/page/${page}/include_deleted/0${
    startDate && finishDate
      ? `/date_from/${format(startDate, 'YYYY-MM-DD')}/date_to/${format(
          finishDate,
          'YYYY-MM-DD',
        )}`
      : ''
  }`
}

function countEvents(fetch: GlobalFetch, startDate?: Date, finishDate?: Date) {
  return async function(calendarId: number): Promise<IEventsCount> {
    const response = await fetch.fetch(
      buildUrl(calendarId, 1, 0, startDate, finishDate),
    )

    const body: IData = await response.json()

    return {
      count: Number(body.count) || 0,
      maxPage: Number(body.max_page) || 0,
    }
  }
}

export default countEvents

export interface IEventsCount {
  count: number
  maxPage: number
}
